import axios from 'axios';
import commonInterceptors from '@/interceptors/commonInterceptors.interceptor.js';
import syncInterceptors from '@/interceptors/syncInterceptors.interceptor.js';

const pixAxiosSyncRequests = axios.create();

commonInterceptors.setCommonInterceptors(pixAxiosSyncRequests);

syncInterceptors.setSyncInterceptors(pixAxiosSyncRequests);

export default pixAxiosSyncRequests;
